import { Marquee } from '@repo/ui/components/marquee';

import { landingContent } from '@/constants/landing-content';

const { partners } = landingContent;

export function PartnersSection() {
  return (
    <section className="bg-muted/30 py-12">
      <div className="container mx-auto max-w-6xl px-4">
        <p className="text-muted-foreground mb-8 text-center text-sm">
          {partners.label}
        </p>

        <Marquee pauseOnHover className="[--duration:30s]">
          {partners.logos.map((logo) => (
            <div
              key={logo.name}
              className="text-muted-foreground mx-8 flex items-center gap-2"
            >
              <svg
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span className="text-sm font-medium">{logo.name}</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
